import originFetch from './origin-fetch';
export default async <T>(
  url: string,
  param?: Record<string, any>,
  autoTip?: boolean,
  headers?: HeadersInit,
) => originFetch<T>(url, 'PUT', param, headers, autoTip);
